import { FC, KeyboardEvent } from 'react'

import Input from 'components/app/input'
import AnimatedIconValid from 'components/ui/animated-icon-valid'
import cn from 'classnames'

import styles from './styles.module.scss'
import { useTranslation } from 'utils/use-translation'

interface Props {
  value: string
  onChange: (email: string) => void
  isValid?: boolean
  isVisibleError?: boolean
  onEnter?: () => void
  readonly?: boolean
  errorMessage?: string
  toHideErrorMessage?: boolean
  onKeyDown?: (key: KeyboardEvent<HTMLInputElement>) => void
}

export const InputEmail: FC<Props> = ({
  isValid,
  isVisibleError,
  onChange,
  onEnter,
  value,
  readonly,
  errorMessage,
  toHideErrorMessage,
  onKeyDown,
}) => {
  const { t } = useTranslation()
  
  const isError = isValid === false && isVisibleError

  const handleChange = (value): void => {
    onChange?.(value.target.value)
  }

  return (
    <div className={cn(styles.input, { [styles.error]: isError })}>
      <Input
        onEnter={onEnter}
        readOnly={isValid || readonly}
        type="text"
        onChange={handleChange}
        placeholder="example@domain.com"
        value={value}
        onKeyDown={onKeyDown}
      />
      {!toHideErrorMessage && (isError || errorMessage) && (
        <span className={styles.incorrectMessage}>{errorMessage || t('incorrect_email')}</span>
      )}
      {isValid && <AnimatedIconValid />}
    </div>
  )
}
